document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('[data-link]').forEach(function(element) {
		element.addEventListener('click', function(e) {
			window.location = element.getAttribute('data-link');
		});
	});
});
